
import { apiData } from './UserStore.js';
import { writable } from 'svelte/store';
import { showModal } from "./Modal";

export const authenticated = writable({});
export const CurrentWindow = writable({});
export const loading = writable({});

// Set default window
CurrentWindow.set("HomeWindow");
//CurrentWindow.set("GiftCode");
//CurrentWindow.set("ClanWindow");


function findEnvironment() {
  // Check if is client side
  if (typeof window !== 'undefined' && window.document !== undefined) {
    // check production hostname
    if (window?.location.hostname !== undefined &&
        window.location.hostname === 'localhost') {
      return "IRAN_TEST"
    }
    else if (window?.location.hostname !== undefined &&
        window.location.hostname === 'supporttest.dabernasho.ir') {
      return "IRAN_TEST"
    }
    else if (window?.location.hostname !== undefined &&
        window.location.hostname === 'support.dabernasho.ir') {
      return "IRAN"
    }
    else if (window?.location.hostname !== undefined &&
        window.location.hostname === 'api.eternalbits.net') {
      return "GLOBAL_TEST"
    }
    else if (window?.location.hostname !== undefined &&
        window.location.hostname === 'api.bingobits.net') {
      return "GLOBAL"
    }
    else {
      return "not found"
    }
  }
  else {
    return "not found"
  }
}

export const ReleaseMode = findEnvironment();  // GLOBAL_TEST, IRAN_TEST, IRAN, GLOBAL



let BaseApi = "http://localhost:8081/api/Support/"; 

if (ReleaseMode == "GLOBAL_TEST") {
  BaseApi = "https://api.eternalbits.net/api/Support/";
}
else if (ReleaseMode == "IRAN_TEST") {
  BaseApi = "https://apitest.dabernasho.ir/api/Support/";
}
else if (ReleaseMode == "IRAN") {
  BaseApi = "https://api.aheadgames.ir/api/Support/";
}
else if(ReleaseMode == "GLOBAL"){
  BaseApi = "https://api.bingobits.net/api/Support/";
}
  
// local
// const BaseApi = "http://localhost:8081/api/Support/";




let AccessToken = "";

export function GetUserData(selectedOption, inputText, onSucces) {
  
  apiData.set({});

  let api = "GetUserByName";
  let query = "username=" + inputText;

  if (selectedOption == "Email") {
    api = "GetUserByEmail";
    query = "email=" + inputText;
  }
  else if (selectedOption == "ReferralCode") {
    api = "GetUserByReferralCode";
    query = "referralCode=" + inputText;
  }
  else if (selectedOption == "Id"){
    api = "GetUser";
    query = "userId=" + inputText;
  }
  else if (selectedOption == "DeviceId"){
    api = "GetUserByActiveDeviceId";
    query = "deviceId=" + inputText;
  }
  else if (selectedOption == "PhoneNumber"){
    api = "GetUserByPhoneNumber";
    query = "phoneNumber=" + inputText;
  }

  SendRequest(api, 'POST', query, (response) => {
    apiData.set(response);
    if(typeof onSucces !== "undefined")
        onSucces(response)
  }, (error) => {
    console.log(error);
    showModal("Error", "User not found", "OK");
  })
}

export function LoadAuthData(){
  let user = localStorage.getItem('user');
  let pass = localStorage.getItem('pass');
  let token = localStorage.getItem('token');
  AccessToken = token;
  let authData = {user: user, token: token, authenticated: true, pass: pass };
  if(user && pass){
    authenticated.set(authData);
  }
  return authData;
}

export function Logout(){
  localStorage.removeItem('user');
  localStorage.removeItem('pass');
  localStorage.removeItem('token');
  authenticated.set({authenticated: false});
}

export function Login(user, pass, rememberMe){
  return SendRequest('GetAuthToken', 'POST', 'user=' + user + '&pass=' + pass, (response) => {
    authenticated.set({user: response.User, token: response.Token, authenticated: true, pass: pass });
    response.pass = pass;
    AccessToken = response.Token;
    if(rememberMe)
    {
      localStorage.setItem('user', response.User);
      localStorage.setItem('pass', response.pass);
      localStorage.setItem('token', response.Token);
    }
  }, (error) => {
    console.log(error);
    authenticated.set({authenticated: false});
  })
}

function showLoading () {
  loading.set({ isLoading : true});
}
function hideLoading () {
  loading.set({ isLoading : false});
}

export function PostRequestWithBody(api, method, body, onSucces, onFailed, retryCount){
  return  SendRequest(api, method, "", onSucces, onFailed, retryCount, body);
}


export function SendRequest(api, method, queryString, onSucces, onFailed, retryCount, body){

  
  if(typeof retryCount == "undefined"){
    retryCount = 3;
  }
  if(retryCount < 0){
    onFailed("Max retry reached!");
    return;
  }

  showLoading();
    const settings = {
        method: method,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization' : 'bearer ' + AccessToken,
            'Access-Control-Allow-Origin' : '*'
        },
      body: JSON.stringify(body)
    };

    let url = BaseApi + api;
    if(typeof queryString !== "undefined"){
        url = url + '?' + queryString;
    }

    return fetch(url, settings)
    .then(response => {

      if (!response.ok) {
        if (response.status === 401) {
          // if we have user data lets try to get auth token again
          let authData = LoadAuthData();
          if(typeof authData != "undefined"){
            Login(authData.user, authData.pass, true)
            .then(() => SendRequest(api, method, queryString, onSucces, onFailed, --retryCount));
            hideLoading ()
            return "ignore";
          }
          else{
            authenticated.set({authenticated: false});
            hideLoading ()
            return "ignore";
          }
        } 
        else if(response.status === 400){
          // bad request
          response.json().then(data => {
            let error = data.Message ?? data;
            if(typeof onFailed !== "undefined")
              onFailed(error);
            else
              showModal("Error", error, "OK");
          });
          hideLoading ()
          return "ignore";
        }
        else {
          showModal("Error", "Bad Request ¯\\_(ツ)_/¯", "OK"); 
        }
        throw new Error(response);
      }
      if (response.status === 204){
        return "{}";
      }
      return response.text()
    })
    .then(data => {
      console.log("Request Success : " + api);
      if (!data){
        data = "{}";
      }
      if (data == "ignore"){
        return;
      }
      data = JSON.parse(data);
      if(typeof onSucces !== "undefined")
        onSucces(data)
      hideLoading ()
    }).catch(error => {
      console.log(JSON.stringify(error));
      if(typeof onFailed !== "undefined")
        onFailed(JSON.stringify(error));
      else
      showModal("Error", JSON.stringify(error), "OK");
      hideLoading ()
    });

}

export function SendDownloadExcelRequest(api, method, fileName) {
  const url = BaseApi + api;
  const headers = {
    Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "Content-Type": "application/json",
    Authorization: "bearer " + AccessToken,
  };

  showLoading();
  fetch(url, { method: method, headers: headers })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.blob();
    })
    .then((blob) => {
      const fileURL = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = fileURL;
      a.download = fileName + ".xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      hideLoading();
    })
    .catch((error) => {
      console.error("Failed to download the Excel file:", error);
      showModal("Error", "Failed to download the Excel file: " + error.message, "OK");
      hideLoading();
    });
}

export async function SendDownloadJsonRequest(api, method, fileName) {
  const url = `${BaseApi}${api}`;
  const headers = {
    Accept: "application/json",
  };

  if (AccessToken) {
    headers["Authorization"] = "Bearer " + AccessToken;
  }

  console.log("📡 Fetching:", url);
  console.log("🔐 Headers:", headers);

  try {
    const response = await fetch(url, { method, headers });

    console.log("📥 Response status:", response.status);

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`HTTP ${response.status} – ${text}`);
    }

    const blob = await response.blob();

    const a = document.createElement("a");
    const fileURL = window.URL.createObjectURL(blob);
    a.href = fileURL;
    a.download = `${fileName}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(fileURL);

    console.log("✅ File downloaded successfully");
  } catch (error) {
    console.error("❌ Failed to download the JSON file:", error);
  }
}
